import { QUERY_KEYS } from '~/constants/react-query'
import { REFETCH_ORG_PLAN } from '~/constants/refetch-intervals'
import { useActiveOrgId } from '~/hooks/org'
import { PlanName } from '~/hooks/usePlans'
import { useQueryWrapper } from '~/hooks/useQueryWrapper'
import { useServerRequests } from '~/hooks/useRequests'

type OrgPlan = {
  plan: PlanName
  /** The Earn balance alone holds the plan, by the server's rule (which tolerates vault share rounding) */
  earnBacked: boolean
}

export const useOrgPlan = ({
  refetchInterval = REFETCH_ORG_PLAN,
}: { refetchInterval?: number } = {}) => {
  const orgId = useActiveOrgId()
  const { serverGetRequest } = useServerRequests()

  return useQueryWrapper<OrgPlan>({
    queryKey: [QUERY_KEYS.ORG_PLAN, orgId],
    queryFn: async () => {
      if (!orgId) throw new Error('Org ID required')

      const result = await serverGetRequest<OrgPlan>({
        path: '/api/org/plan',
        params: { orgId },
      })
      if (!result) throw new Error('Failed to fetch org plan')

      return result.data
    },
    enabled: !!orgId,
    refetchInterval,
  })
}
